import React from 'react'
import { FlexContainer, TextBase, Button } from '@reapit/elements'

type props = {
    onclick : ()=>void,
    headers: Record<string, any>
};
const AutoCallHeader: React.FC<props> = ({onclick, headers}) => {

    const handleToggle = () =>{
        onclick();
    }
    return (
        <FlexContainer
            isFlexWrap
            isFlexAlignCenter
            className="reapit-banner"
            style={{
                backgroundColor: '#eef4ff',
                padding: '1rem',
                borderRadius: '0.5rem',
                fontSize: '0.875rem',
                margin: '0 0 1rem 0',
            }}
        >
            <FlexContainer isFlexWrap isFlexGrow1>
                {Object.entries(headers).map(([label, value]) => (
                    <TextBase key={label} style={{ paddingRight: '1rem' }}>
                        {label}: <strong>{value}</strong>
                    </TextBase>
                ))}
            </FlexContainer>

            <div className="el-mb3 el-flex el-flex-row ">
                <span className="flex items-center text-blue-600 ml-auto pointer"
                      onClick={handleToggle}
                      style={{
                          color: '#1921d0',
                          textDecoration: 'underline'
                      }}
                >
                    <span role="img" aria-label="edit" className="el-mr1">
                      ✏️
                    </span>
                    Edit
                </span>
            </div>
        </FlexContainer>
    )
}

export default AutoCallHeader